import { useNavigate } from 'react-router-dom';
import Brand from '../../../assets/brand/brand-dark.png';

import Button from "../../../components/Button";
import PricingTable from "../../../components/Tables/Pricing";

import './styles.css';

const Models = () => {
    const navigate = useNavigate();

    const pricing = [
        {
            "papayia_model_id": "papayia-chat-grain-001",
            "papayia_price_1m_input": 0.30,
            "papayia_price_1m_input_intent": 0.375,
            "papayia_price_1m_output": 3.6,
            "papayia_price_1m_ouput_intent": 4.5,
            "papayia_context_length": 110000,
            "typeProject": ["managed", "stateless"]
        },
        {
            "papayia_model_id": "papayia-chat-grain-002",
            "papayia_price_1m_input": 0.10,
            "papayia_price_1m_input_intent": 0.125,
            "papayia_price_1m_output": 0.80,
            "papayia_price_1m_ouput_intent": 1.00,
            "papayia_context_length": 380000,
            "typeProject": ["managed", "stateless"]
        },
        {
            "papayia_model_id": "papayia-chat-grain-003",
            "papayia_price_1m_input": 0.50,
            "papayia_price_1m_input_intent": 0.625,
            "papayia_price_1m_output": 3.00,
            "papayia_price_1m_ouput_intent": 3.75,
            "papayia_context_length": 380000,
            "typeProject": ["managed", "stateless"]
        },
        {
            "papayia_model_id": "papayia-chat-seed-001",
            "papayia_price_1m_input": 3,
            "papayia_price_1m_input_intent": 3.75,
            "papayia_price_1m_output": 6,
            "papayia_price_1m_ouput_intent": 7.5,
            "papayia_context_length": 180000,
            "typeProject": ["managed", "stateless"]
        },
        {
            "papayia_model_id": "papayia-chat-seed-002",
            "papayia_price_1m_input": 3.75,
            "papayia_price_1m_input_intent": 4.6875,
            "papayia_price_1m_output": 15,
            "papayia_price_1m_ouput_intent": 18.75,
            "papayia_context_length": 350000,
            "typeProject": ["managed", "stateless"]
        },
        {
            "papayia_model_id": "papayia-chat-nectar-001",
            "papayia_price_1m_input": 5,
            "papayia_price_1m_input_intent": 6.25,
            "papayia_price_1m_output": 25,
            "papayia_price_1m_ouput_intent": 31.25,
            "papayia_context_length": 180000,
            "typeProject": ["stateless"]
        },
        {
            "papayia_model_id": "papayia-chat-nectar-002",
            "papayia_price_1m_input": 6,
            "papayia_price_1m_input_intent": 7.5,
            "papayia_price_1m_output": 36,
            "papayia_price_1m_ouput_intent": 37.5,
            "papayia_context_length": 360000,
            "typeProject": ["stateless"]
        },
        {
            "papayia_model_id": "papayia-text-bran-001",
            "papayia_price_1m_input": 0.15,
            "papayia_price_1m_output": 0,
            "papayia_context_length": 8000
        },
    ]

    return (
        <div className='pricing-models-container'>
            <div className='pricing-models-content'>
                <div className='pricing-models-header'>
                    <img src={Brand} alt=""/>
                    <div style={{ display: 'flex', gap: 32 }}>
                        <Button 
                            kind="link"
                            label="Dashboard"
                            onClick={() => navigate('/')}
                            style={{ padding: 0, width: 'auto' }}
                        />
                        <Button 
                            kind="link"
                            label="Documentation"
                            onClick={() => window.open('https://papayia.readme.io/', '_blank')}
                            style={{ padding: 0, width: 'auto' }}
                        />
                    </div>
                </div>
                <div className='pricing-models-body'>
                    <div>
                        <h4>Text tokens</h4>
                        <p>
                            The text models are designed for tasks that require understanding and generating text, 
                            such as summarization, translation, and content generation.
                        </p>
                        <PricingTable 
                            columns={[
                                { label: 'Model', key: 'papayia_model_id' },
                                { label: 'Input Price', key: 'papayia_price_1m_input' },
                                { label: 'Output Price', key: 'papayia_price_1m_output' }
                            ]}
                            pricing={pricing.filter(model => [
                                "papayia-chat-grain-001",
                                "papayia-chat-grain-002", 
                                "papayia-chat-grain-003", 
                                "papayia-chat-seed-001", 
                                "papayia-chat-seed-002", 
                                "papayia-chat-nectar-001",
                                "papayia-chat-nectar-002"
                            ].includes(model.papayia_model_id))} 
                        />
                    </div>
                    <div>
                        <h4>Intentions Model</h4>
                        <p>
                            Intents are configurable parameters that allow you to classify 
                            and monitor up to five distinct categories of interaction in a conversational chat.
                        </p>
                        <PricingTable 
                            columns={[
                                { label: 'Model', key: 'papayia_model_id' },
                                { label: 'Input Price', key: 'papayia_price_1m_input_intent' },
                                { label: 'Output Price', key: 'papayia_price_1m_ouput_intent' }
                            ]}
                            pricing={pricing.filter(model => [
                                "papayia-chat-grain-001", 
                                "papayia-chat-grain-002", 
                                "papayia-chat-grain-003", 
                                "papayia-chat-seed-001", 
                                "papayia-chat-seed-002"
                            ].includes(model.papayia_model_id))} 
                        />
                    </div>
                    <div>
                        <h4>Embeddings</h4>
                        <p>
                            The embedding models are designed for tasks that require understanding the semantic meaning of text, such as search, recommendation, and clustering.
                        </p>
                        <PricingTable 
                            columns={[
                                { label: 'Model', key: 'papayia_model_id' },
                                { label: 'Input Price', key: 'papayia_price_1m_input' },
                            ]}
                            pricing={pricing.filter(model => ["papayia-text-bran-001"].includes(model.papayia_model_id))} 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Models;